<template>
  <div class="wrapper">
    <notifications></notifications>
    <side-bar>
      <template slot="links">
        <sidebar-item
          v-if="plantaSelected !== 'all'"
          :link="{
            name: 'Dashboard',
            path: '/dashboard',
            icon: 'ni ni-chart-pie-35 text-primary',
          }"
        />
        <sidebar-item
          opened
          :link="{
            name: 'Gestión de Activos',
            icon: 'ni ni-app text-primary',
          }"
        >
          <sidebar-item
            :link="{
              name: 'Todos los Equipos',
              path: '/activo-management/list-activos',
            }"
          />
          <sidebar-item
            :link="{
              name: 'EPIs',
              path: '/activo-management/list-epis',
            }"
          />
          <sidebar-item
            :link="{
              name: 'Herramientas',
              path: '/activo-management/list-herramientas',
            }"
          />
          <sidebar-item
            :link="{
              name: 'Dispositivos de Anclaje',
              path: '/activo-management/list-anclaje',
            }"
          />
          <sidebar-item
            :link="{
              name: 'Fin Vida Útil',
              path: '/activo-management/list-fin-vida-util',
            }"
          />
          <sidebar-item
            :link="{
              name: 'Retirados',
              path: '/activo-management/list-retirados',
            }"
          />
        </sidebar-item>

        <template v-if="plantaSelected !== 'all'">
        <sidebar-item
          v-if="plantaSelected === '172'"
          opened
          :link="{
            name: 'Trazabilidad',
            icon: 'ni ni-delivery-fast text-primary',
          }"
        >
          <sidebar-item
            :link="{
              name: 'Albaranes entrega',
              path: '/albaran-management/list-albaranes',
            }"
          />
          <sidebar-item
            :link="{
              name: 'Partes',
              path: '/partes',
            }"
          />
          <sidebar-item
            :link="{
              name: 'Incidencias albaranes',
              path: '/albaran-management/incidencias-albaranes',
            }"
          />
          <sidebar-item
            :link="{
              name: 'Keikaku',
              path: '/keikaku',
            }"
          />
          <sidebar-item
            :link="{
              name: 'Poal',
              path: '/poal',
            }"
          />
        </sidebar-item>

          <sidebar-item
            v-if="plantaSelected === '134' || plantaSelected === '15'"
            opened
            :link="{
              name: 'Inspección Visual',
              path: '/inspeccion-visual/list',
              icon: 'ni ni-zoom-split-in text-primary',
            }"
          >
        </sidebar-item>

          <sidebar-item
            v-if="plantaSelected === '134'"
            :link="{
              name: 'Vida útil modelos',
              path: '/modelo-management/vida-util-modelos',
              icon: 'ni ni-watch-time text-primary',
            }"
          />

        <sidebar-item
          :link="{
            name: 'Empleados',
            path: '/user-management/list-employees',
            icon: 'ni ni-single-02 text-primary',
          }"
        />
        <sidebar-item
          :link="{
            name: 'Incidencias',
            path: '/incidencia-management/list-incidencias',
            icon: 'ni ni-support-16 text-primary',
          }"
        />
        <sidebar-item
          :link="{
            name: 'Mensajes',
            icon: 'ni ni-notification-70 text-primary',
          }"
        >
          <sidebar-item
            :link="{
              name: 'Enviados',
              path: '/notificacion-management/list-notificaciones-enviadas',
            }"
          />
          <sidebar-item
            :link="{
              name: 'Recibidos',
              path: '/notificacion-management/list-notificaciones',
            }"
          />
        </sidebar-item>

        <sidebar-item
          :link="{
            name: 'Ajustes',
            icon: 'ni ni-settings-gear-65 text-primary',
          }"
        >
          <sidebar-item
            :link="{
              name: 'Usuarios',
              path: '/user-management/list-users',
            }"
          />
          <sidebar-item
            :link="{
              name: 'Plantas',
              path: '/empresa-management/list-empresa',
            }"
          />
        </sidebar-item>
        </template>
      </template>
    </side-bar>
    <div class="main-content">
      <dashboard-navbar :type="$route.meta.navbarType"></dashboard-navbar>

      <div @click="$sidebar.displaySidebar(false)">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </fade-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

import DashboardNavbar from "./DashboardNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import { FadeTransition } from "vue2-transitions";
import Vuex from "vuex";

export default {
  components: {
    DashboardNavbar,
    ContentFooter,
    FadeTransition,
  },
  data() {
    return {
      roles: [],
      permissions: [],
      /*  permisoAlquiler: false,
      permisoEstadoAlquiler: false,
      permisoEstadoLineaAlquiler: false,
      permisoEstadoUser: false,
      permisoLineaAlquiler: false,
      permisoTipoGestor: false, */
      permisoEmpresa: false,
      plantaSelected: null
    };
  },
  async created() {
    this.plantaSelected = localStorage.getItem("plantaSelected");
  },
  methods: {
    initScrollbar() {
      let isWindows = navigator.platform.startsWith("Win");
      if (isWindows) {
        initScrollbar("sidenav");
      }
    },
  },
  mounted() {
    this.initScrollbar(), this.$store.dispatch("profile/me");
  },
  computed: {
    ...Vuex.mapState({
      me: (state) => state.profile.me,
    }),
    hasInspeccionVisualAccess() {
      const profile = this.$store.getters["profile/me"];
      return (
        profile &&
        profile.empresas &&
        profile.empresas.some(
          empresa =>
            empresa.id === 134 ||
            empresa.nombre === "Salvador SEGURIDAD EN ALTURA"
        )
      );
    },
  },
  watch: {
    me: {
      handler: async function (val) {
        this.roles = [val.role.type];
        await this.$store.dispatch("roles/get", val.role.id);
        var role = this.$store.getters["roles/role"];

        var newPerm = {};
        Object.keys(role.permissions).forEach((key) => {
          if (key.startsWith("api::")) {
            newPerm[key] = role.permissions[key];
          }
        });
        this.permissions = newPerm;
        console.log(this.permissions);
        if (
          this.permissions["api::empresa"]["controllers"]["empresa"]["create"][
            "enabled"
          ] &&
          this.permissions["api::empresa"]["controllers"]["empresa"]["find"][
            "enabled"
          ]
        ) {
          this.permisoEmpresa = true;
        }
      },
      deep: true,
    },
    '$route': {
      handler: function() {
        this.plantaSelected = localStorage.getItem("plantaSelected");
      },
      deep: true
    }
  },
};
</script>
<style lang="scss">
body.g-sidenav-hidden {
  #purchase-button,
  #demo-button,
  #star-button,
  #docs-button {
    margin-left: 8px;
    margin-right: 8px;
    padding: 11px 0px;
  }
}
body.g-sidenav-show {
  #purchase-button,
  #demo-button,
  #star-button,
  #docs-button {
    margin-left: 20px;
    margin-right: 20px;
    padding: 11px 0px;
  }
}
</style>
